import React from 'react';

interface ProtectionLayerProps {
  isVisible: boolean;
  onRestore: () => void;
  reason?: 'focus' | 'command' | 'printscreen';
}

export default function ProtectionLayer({ isVisible, onRestore, reason = 'focus' }: ProtectionLayerProps) {
  if (!isVisible) {
    return null;
  }

  const getContent = () => {
    switch (reason) {
      case 'printscreen':
        return {
          title: 'Captura Bloqueada',
          description: 'Las capturas de pantalla están deshabilitadas para proteger el contenido',
          icon: (
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginBottom: '24px', opacity: 0.9 }}
            >
              <path
                d="M3 3L21 21M9 9V15C9 16.1046 9.89543 17 11 17H13C14.1046 17 15 16.1046 15 15V9M7 7V15C7 17.2091 8.79086 19 11 19H13C15.2091 19 17 17.2091 17 15V7"
                stroke="#ff6b6b"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <rect
                x="9"
                y="3"
                width="6"
                height="4"
                rx="1"
                stroke="#ff6b6b"
                strokeWidth="2"
              />
            </svg>
          ),
        };
      case 'command':
        return {
          title: 'Contenido Protegido',
          description: 'El contenido está temporalmente oculto mientras usas atajos de teclado',
          icon: (
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginBottom: '24px', opacity: 0.9 }}
            >
              <path
                d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="rgba(255, 255, 255, 0.1)"
              />
              <path
                d="M9 12L11 14L15 10"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        };
      default:
        return {
          title: 'Contenido Protegido',
          description: 'El contenido está temporalmente oculto para proteger su privacidad',
          icon: (
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{ marginBottom: '24px', opacity: 0.9 }}
            >
              <path
                d="M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1Z"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="rgba(255, 255, 255, 0.1)"
              />
              <path
                d="M9 12L11 14L15 10"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ),
        };
    }
  };

  const content = getContent();

  return (
    <div
      onClick={onRestore}
      onContextMenu={(e) => e.preventDefault()}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        backgroundColor: '#222',
        pointerEvents: 'auto',
        transition: 'opacity 0.1s ease-in-out',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#ffffff',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        cursor: 'pointer'
      }}
    >
      {content.icon}
      <h3
        style={{
          margin: '0 0 12px 0',
          fontSize: '24px',
          fontWeight: '600',
          textAlign: 'center',
          opacity: 0.95
        }}
      >
        {content.title}
      </h3>
      <p
        style={{
          margin: '0 0 16px 0',
          fontSize: '16px',
          textAlign: 'center',
          opacity: 0.8,
          lineHeight: '1.5',
          maxWidth: '400px',
          padding: '0 20px'
        }}
      >
        {content.description}
      </p>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          fontSize: '14px',
          opacity: 0.7,
          backgroundColor: 'rgba(255, 255, 255, 0.1)',
          padding: '8px 16px',
          borderRadius: '20px',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ marginRight: '8px' }}
        >
          <path
            d="M9 12L11 14L15 10"
            stroke="#ffffff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle
            cx="12"
            cy="12"
            r="10"
            stroke="#ffffff"
            strokeWidth="2"
          />
        </svg>
        Haz click aquí para mostrar el contenido
      </div>
    </div>
  );
}